import { render, staticRenderFns } from "./QRCodeView.vue?vue&type=template&id=72830c97&"
import script from "./QRCodeView.vue?vue&type=script&lang=js&"
export * from "./QRCodeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports